/** Mapa campo→parámetro legible de la URL (sin sufijos técnicos). Única
 * fuente de verdad compartida entre el parseo server-side (`page.tsx`) y la
 * actualización de la URL en cliente (`useListingFieldFilters`, inyectado
 * desde `RecintoEventsFilters`). No hay parámetro de provincia: el recinto
 * ya tiene una ubicación fija (segmento `[location]` de la ruta).
 *
 * Sin `PAGE_SIZE` propio (a diferencia de la primera iteración de esta
 * funcionalidad): el backend pagina `contents` en servidor y expone su
 * `per_page` real en `meta` (segunda iteración, ver `getResourceByUrl`) —
 * igual que el resto de PLPs del sitio (`SubcategoriaResults.pageSize` ←
 * `response.meta.per_page`).
 */
export const READABLE_FILTER_PARAMS = {
  sort: 'sort',
  genre: 'genre',
  dateRange: 'date_range',
  /** Límites del rango continuo de Precio — mismo mecanismo que Promociones/
   * Lo más vendido/Subcategoría, sustituye al antiguo `min_price` de tramo
   * único. */
  priceMin: 'price_min',
  priceMax: 'price_max',
  /** Checkbox "Mostrar solo gratuitos" respaldado por el backend. */
  freeFilter: 'free_filter',
} as const
